import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddUserModalComponent } from './components/add-user-modal/add-user-modal.component';
import { PermitsModalComponent } from './components/permits-modal/permits-modal.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SwiperModule } from 'swiper/angular';
import { FilterPipe } from './pipes/filter.pipe';
import { CategoryPipe } from './pipes/category.pipe';
import { NgxFileDragDropModule } from 'ngx-file-drag-drop';
import { ChunksPipe } from './pipes/chunks.pipe';
@NgModule({
  declarations: [
    AddUserModalComponent,
    PermitsModalComponent,
    FilterPipe,
    CategoryPipe,
    ChunksPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    NgbModule,
    SwiperModule,
  ],
  exports: [
    CommonModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    FilterPipe,
    CategoryPipe,
  ],
})
export class SharedModule {}
